      var slidesPerView = 5;
      var spaceBetween = 20;
      var slidesPerGroup = 1;
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
          slidesPerView = 2;
          spaceBetween = 15;
          slidesPerGroup = 2;
      } 
      var swiper = new Swiper(".swiper-01", {

        spaceBetween: spaceBetween,
        loop: true,
        slidesPerView: slidesPerView,
        slidesPerGroup:slidesPerGroup,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });